import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = { formData: { email: '' }, emailSent: null, redirectTo: null, errors:[], loading: false }
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loginRandom = null;
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
        if (visibilityConfigKey && ConfigBusiness.get(visibilityConfigKey) === "false") return null;
        const slug = ConfigBusiness.get("generales.clienteSlug");
        if (slug && slug !== "false" && slug !== "default") return `${process.env.PUBLIC_URL}/images/branding/${slug}/${defaultFilename}`;
        return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this, validators: { 'formData.email': (value) => Validator.notEmpty(value) }
        });
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');
        if(this.refs.email) this.refs.email.focus();
    }

    handleFormChange(event) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[event.target.name] = event.target.value;
        this.setState({ formData: formDataCopy, errors:[] });
    }

    handleSubmit(event) {
        this.setState({ loading: true, errors:[] });
        fetch(Config.get('apiUrlBase') + '/public/auth/forgot-password/' + this.state.formData.email, {
            method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...this.state.formData }),
        }).then(res => {
            if(res.status === 200) { this.setState({ emailSent: true }); } 
            else if(res.status === 400) { res.json().then(data => this.setState({ errors: data.detalle })).catch(() => this.error()); } 
            else { this.error(); }
        }).catch(() => this.error()).finally(() => this.setState({ loading: false }));
        event.preventDefault();
    }

    handleGoHome(e) { this.setState({ redirectTo: '/' }); e.preventDefault(); }
    error() { swal("Error", "Contacte al administrador.", "error"); }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        const logoAppSrc = this.getBrandedLogo("logo-login-app.png");
        const logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        const logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");

        return (
            <React.Fragment>
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video"+ this.loginRandom +".mp4"} type="video/mp4"/>
                            </video>
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '380px'}}>
                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>
                                            
                                            <div className="card-header border-0 text-center pb-0" style={{paddingTop: '2rem'}}>
                                                <img src={logoAppSrc} alt="App Logo" className="img-fluid center-block" style={{ maxHeight: '90px', objectFit: 'contain' }} onError={(e) => { e.target.onerror=null; e.target.src="/images/company/logo-login-app.png"; }} />
                                            </div>

                                            <div className="card-body" style={{padding: '1.5rem 1.5rem 1rem'}}>
                                                {!this.state.emailSent ? (
                                                    <React.Fragment>
                                                        <h5 className="text-center font-weight-bold text-muted mb-2"><FormattedMessage id="forgotPassword.recover" defaultMessage="Recuperación de contraseña"/></h5>
                                                        <p className="text-center text-muted" style={{fontSize: '13px'}}><FormattedMessage id="forgotPassword.recover.ingrese_email" defaultMessage="Ingrese su e-mail para recuperar su contraseña."/></p>
                                                        
                                                        <form className="form-horizontal mt-2" noValidate onSubmit={this.handleSubmit}>
                                                            <fieldset className="form-group position-relative has-icon-left mb-1">
                                                                <input type="text" className="form-control" style={{borderRadius: '8px', height:'42px'}} name="email" placeholder="E-mail" ref="email" required onChange={this.handleFormChange} />
                                                                <div className="form-control-position" style={{top:'1px'}}><i className="la la-at"></i></div>
                                                            </fieldset>
                                                            
                                                            <div className="text-center mb-1" hidden={this.state.errors.length===0} style={{minHeight:'18px'}}>
                                                                <small className="text-danger font-weight-bold">{this.state.errors.map((e, i) => <span key={i}><FormattedMessage {...(backendStrings[e] || {id:e, defaultMessage:e})}/> </span>)}</small>
                                                            </div>
                                                            
                                                            <button type="submit" className="btn btn-primary btn-block shadow-sm" style={{borderRadius: '8px', height:'42px', fontWeight: '500'}} disabled={!validationState.form.valid}>
                                                                <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-check'}></i> Enviar
                                                            </button>
                                                        </form>
                                                    </React.Fragment>
                                                ) : (
                                                    <div className="text-center py-2">
                                                        <i className="la la-envelope" style={{fontSize: '60px', color:'#00c0bd'}}></i>
                                                        <h5 className="font-weight-bold mt-2 text-success">¡Le enviamos un e-mail!</h5>
                                                        <p className="text-muted" style={{fontSize:'13px'}}>Verifique su casilla de correo con las instrucciones.</p>
                                                    </div>
                                                )}

                                                <div className="text-center mt-3">
                                                    <button className="btn btn-link text-muted" style={{textDecoration: 'none', fontSize:'13px'}} onClick={this.handleGoHome.bind(this)}>
                                                        <i className="la la-arrow-left"></i> Volver al inicio
                                                    </button>
                                                </div>

                                                <div className="mt-3 pt-2" style={{borderTop: '1px solid #f3f3f3'}}>
                                                    <div className="row align-items-center">
                                                        <div className="col-6 text-left">{logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror=null; e.target.src="/images/company/logo-login-company.png"; }} />}</div>
                                                        <div className="col-6 text-right">{logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '30px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror=null; e.target.src="/images/company/logo-login-powered-by.png"; }} />}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default injectIntl(ForgotPassword);
